import { green, red, yellow } from "@material-ui/core/colors";
import styled from "styled-components";
import LensIcon from "@material-ui/icons/Lens";

const colorByState = {
  enable: green.A200,
  disable: red.A200,
  warning: yellow[800],
};

const StatusIcon = styled(LensIcon)<{
  state?: "enable" | "disable" | "warning";
}>`
  font-size: 0.7rem;
  margin-right: 6px;
  color: ${props => colorByState[props.state ?? "disable"]};
`;

export default StatusIcon;
